<div class="main-wrapper" [ngClass]="">
  <router-outlet></router-outlet>
  <app-table [slug]="slug" [systemName]="systemName"></app-table>
</div>
